module.exports = __webpack_public_path__ + "img/back3.73c216c8.png";